export const genVW = (px: number | string) => {
  //保留两位小数
  return `${(Number(px) * 100 / 375).toFixed(2)}vw`
}